export const KrameriusJobMapping: Record<string, string> = {
	CREATE_ENRICHMENT_REQUEST: 'Vytvoření žádosti o obohacení',
	ENRICHMENT_EXTERNAL: 'Obohacení externími nástroji',
	ENRICHMENT_NDK: 'Obohacení NDK',
	ENRICHMENT_TEI: 'Obohacení TEI',
	EXPORT_JSON: 'Export JSON',
	EXPORT_CSV: 'Export CSV',
	EXPORT_TEI: 'Export TEI',
	EXPORT_ALTO: 'Export ALTO',
	EXPORT_TEXT: 'Export TEXT',
}
